import { gql, useMutation } from '@apollo/client'
import { userFollowsVar } from 'modulesCommon/store'

export const UNFOLLOW_PROJECT = gql`
  mutation ($campaign_id: String!) {
    unfollowCampaign(campaign_id: $campaign_id) {
      id
      campaign_id
      user_id
    }
  }
`

export const useUnfollowProject = (campaignId: string) => {
  const [mutate, { data, error, loading }] = useMutation(UNFOLLOW_PROJECT, {
    variables: { campaign_id: campaignId },
    onCompleted: ({ unfollowCampaign }) => {
      const currentFollows = userFollowsVar()
      userFollowsVar([...currentFollows].filter((item) => item.campaign_id !== unfollowCampaign.campaign_id))
    },
    update(cache) {
      cache.modify({
        fields: {
          getUserFollows() {}
        }
      })
    }
  })

  return { mutate, data, error, loading }
}
